// extracted by mini-css-extract-plugin
export default {"ul":"_1ZEA","link":"_1C3G","stage":"_3F3E","linkActive":"_2fBB"};